module.exports = {"description":"","displayName":"NavList","methods":[],"props":{"children":{"type":{"name":"node"},"required":false,"description":"List content (NavItems)"},"layout":{"type":{"name":"enum","value":[{"value":"'horizontal'","computed":false},{"value":"'vertical'","computed":false}]},"required":false,"description":"How to lay out the list items","defaultValue":{"value":"'horizontal'","computed":false}},"cssMap":{"defaultValue":{"value":"require( './navList.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/NavList-props.json
// module id = 447
// module chunks = 0